import fp from 'lodash/fp'

const createFormatFunction = (prop) =>
  fp.map((option) => {
    const { [prop]: id, description } = option

    return {
      id,
      name: description || fp.capitalize(id),
    }
  })

export const listTriggers = (triggers) => {
  return triggers.map((item) => {
    return {
      id: item.id,
      name: item.description,
    }
  })
}

export const listBeneficiary = (beneficiarys) => {
  return beneficiarys.map((item) => {
    return {
      id: item.id,
      name: item.beneficiaryName,
    }
  })
}

export const listSponsors = (sponsors) => {
  return sponsors.map((item) => {
    return {
      id: item.id,
      name: item.fullName,
      limit: item.sponsorLimit,
    }
  })
}

export const formatCategories = createFormatFunction('sport')

export const getOptionLabel = fp.prop('name')

export const getOptionValue = fp.prop('id')

export const calcTotalAmount = (form) => {
  const amount = Number(form.fields.amount.value) || 0
  const sponsorAmount = Number(form.fields.sponsorAmount.value) || 0
  form.fields.totalAmount.onChange({
    target: { value: amount + sponsorAmount },
  })
}
